<template>
  <div class="container-fluid" id="offerexpired-step">
    <h2 class="text-center mt-2">{{ t("WERESORRY") }}</h2>
    <img
      alt="sorry no"
      :src="`${useAsset('img/credit-line/sorryno.png')}`"
      class="mx-auto d-block"
    />
    <div id="other-offer-card" class="mt-4 mb-5">
      <p>{{ t("OFFEREXPIRED") }}</p>
      <hr />
      <a href="javascript:;" @click="$router.go(0)" class="reject-link">
        {{ t("TRYAGAIN") }}
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

export default defineComponent({
  name: "RegistrationOfferExpired",
  methods: { useAsset },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.reject-link {
  font-weight: 600;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.24px;
  color: $pj-color-green !important;
  text-decoration: none;
}

#other-offer-card {
  padding: 5%;
  background-color: $pj-color-green-hover;
  border-radius: 5%;
}
</style>
